module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/company2-2a79c26d543ea7bacc171b0f7dd675fa.jpg";